import classNames from 'classnames';
import { FC } from 'react';

import { Link, Text } from '@servicetitan/anvil2';
import { useDependencies } from '@servicetitan/react-ioc';

import { LocationItemModel, LocationListModel } from '../../../models/location.model';
import { MessageType } from '../../../models/message-type.model';
import { ChatStore } from '../../../stores/chat.store';
import { MessageCard } from '../../message-card/message-card';

interface LocationListProps {
    data: LocationListModel;
}

export const LocationList: FC<LocationListProps> = ({ data }) => {
    const [chatStore] = useDependencies(ChatStore);

    const handleShowMore = (location: LocationItemModel) => {
        chatStore.enqueueMessages([
            {
                isMine: false,
                type: MessageType.RichText,
                showAvatar: true,
                text: `Here is information about the Location <strong>#${location.location_id}</strong>:`,
            },
            {
                isMine: false,
                type: MessageType.LocationDetail,
                data: location.details,
            },
        ]);
    };

    return data.locations.map((location, index) => (
        <MessageCard
            key={location.location_id}
            className={classNames(index > 0 && 'm-t-2')}
            flexDirection="column"
        >
            <Text variant="headline" el="h3" size="small">
                {location.customer}
            </Text>

            <div className="m-b-1">
                <Text variant="eyebrow" className="m-b-half" size="small">
                    Address
                </Text>
                <Text size="small">{location.address}</Text>
            </div>

            <Link
                quiet
                appearance="primary"
                className="m-t-1"
                onClick={() => handleShowMore(location)}
            >
                View more info
            </Link>
        </MessageCard>
    ));
};
